import { TableBody, TableHead } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import axios from "../../login/Axios-interceptor";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

// import Button from "@mui/material/Button";
// import axios from "axios";
import "./AdminComponents.scss";

import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";

import { Grid, Button } from "@mui/material";
import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

function DoctorList({ refreshList }) {
  const [userData, setUserData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const [doctorlist, setDoctorsList] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
  const [userIdToReactivate, setUserIdToReactivate] = useState(null);
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     (sessionStorage.getItem("roleType") !== "admin" &&
  //       sessionStorage.getItem("roleType") !== "facility admin")
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (
      (sessionStorage.getItem("roleType") === "admin" ||
        sessionStorage.getItem("roleType") === "facility admin") &&
      Token()
    ) {
      fetchDoctors();
    }
  }, [authToken, refreshList]);

  function fetchDoctors() {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_doctors/`, {
          headers: headers,
        })
        .then((response) => {
          const doctorsWithId = response.data?.data.map((doctor, index) => ({
            ...doctor,
            id: index + 1, // You can use a better strategy to generate unique IDs
          }));
          setDoctorsList(doctorsWithId);
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }
  const getRowClassName = (params) => {
    return "custom-row";
  };

  const columns = [
    { field: "salutation", headerName: "salutation", width: 100 },
    { field: "name", headerName: "Name", width: 150 },
    { field: "hospital", headerName: "Facility", width: 150 },
    { field: "phone_no", headerName: "Phone Number", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
    {
      field: "specialization",
      headerName: "Specialization",
      width: 150,
    },

    {
      field: "qualifications",
      headerName: "Qualifications",
      width: 200,
    },
    {
      field: "registration_no",
      headerName: "Registration No.",
      width: 200,
    },
    {
      field: "dob",
      headerName: "Date of Birth",
      width: 150,
    },
    {
      field: "active",
      headerName: "Status",
      width: 100,
      renderCell: (params) => (
        <div
          style={{ color: params.value ? "green" : "red", fontWeight: "bold" }}
        >
          {params.value ? "Active" : "Inactive"}
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <>
          {params.row.active ? (
            <button
              onClick={() => handleDeleteUser(params.row.dr_id)}
              style={{ color: "red", fontWeight: "bold" }}
            >
              Delete
            </button>
          ) : (
            <button
              onClick={() => handleReactivateUser(params.row.dr_id)}
              style={{ color: "green", fontWeight: "bold" }}
            >
              Reactivate
            </button>
          )}
        </>
      ),
    },
  ];

  const handleDeleteUser = (userId) => {
    setUserIdToDelete(userId);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (userIdToDelete) {
      console.log("deleting..", userIdToDelete);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}deactivate_facility_user/${userIdToDelete}/`,
          { type: "doctor_user" },
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("User deleted successfully:", res.data);
          toast.success("Doctor Deleted Successfully");
          fetchDoctors();
        })
        .catch((err) => {
          console.error("Error deleting user:", err);
          toast.error("Doctor Deletion Unsuccessfull");
        })
        .finally(() => {
          setUserIdToDelete(null);
          setIsDeleteModalOpen(false);
        });
    }
  };

  const handleReactivateUser = (userId) => {
    setUserIdToReactivate(userId);
    setIsReactivateModalOpen(true);
  };

  const handleConfirmReactivate = () => {
    if (userIdToReactivate) {
      console.log("reactivating..", userIdToReactivate);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}activate_facility_user/${userIdToReactivate}/`,
          { type: "doctor_user" },
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("User reactivated successfully:", res.data);
          if (res.data.status === "Success") {
            toast.success("Doctor Activated Successfully");
            fetchDoctors();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error("Error reactivating user:", err);
          toast.error("Error reactivating user");
        })
        .finally(() => {
          setUserIdToReactivate(null);
          setIsReactivateModalOpen(false);
        });
    }
  };

  const handleCancelReactivate = () => {
    setUserIdToReactivate(null);
    setIsReactivateModalOpen(false);
  };

  const handleCancelDelete = () => {
    setUserIdToDelete(null);
    setIsDeleteModalOpen(false);
  };

  const generatePdf = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [["Salutation", "Name", "Facility", "Phone number", "Email", "Specialization", "Qualifications", "Registration No.", "Date of Birth", "Status",]],
      body: doctorlist.map((dl) => [
        dl.salutation,
        dl.name,
        dl.hospital,
        dl.phone_no,
        dl.email,
        dl.specialization,
        dl.qualifications,
        dl.registration_no,
        dl.dob,
        dl.active,
      ]),
    });
    doc.save("Doctors_List.pdf");
  };

  const generateCsvData = () => {
    return doctorlist.map((dl) => ({
      "Facility": dl.hospital,
      "Salutation": dl.salutation,
      "Name": dl.name,
      "Phone Number": dl.phone_no,
      "Email": dl.email,
      "Specialization": dl.specialization,
      "Qualifications": dl.qualifications,
      "Registration No.": dl.registration_no,
      "Date of Birth": dl.dob,
      "Status": dl.active,
    }));
  };

  // console.log(doctorlist, "fetchDoctors()");
  return (
    <>
      <Modal
        open={isDeleteModalOpen}
        onClose={handleCancelDelete}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="confirm-delete-modal"
        aria-describedby="confirm-delete-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: {
              xs: "98%", // Mobile
              sm: "85%", // Tablet
              md: "70%", // Small desktop
              lg: "60%", // Large desktop
            },
            maxWidth: "700px",
            // minHeight: {
            //   xs: "200px", // Mobile
            //   sm: "250px", // Tablet
            //   md: "300px", // Small desktop
            //   lg: "350px", // Large desktop
            // },
          }}
        >
          <h3 id="confirm-delete-modal" style={{ marginTop: 0, fontSize: "32px" }}>
            Confirm Deletion
          </h3>
          <p id="confirm-delete-description" style={{ fontSize: "20px" }}>
            Are you sure you want to delete this doctor?
          </p>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              mt: "10%",
            }}
          >
            <Button
              onClick={handleCancelDelete}
              className="button button-contained-cancel"
              sx={{
                backgroundColor: "#FFBD8A", padding: "8px 14px", border: "1px solid #FF8D28", borderRadius: "10px", color: "#000000", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#FFBD8A", // Maintain same background color on hover
                  border: "1px solid #FF8D28", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#A1DA3B",
                padding: "8px 14px",
                border: "1px solid #8DC63F",
                borderRadius: "10px",
                color: "#000000",
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#A1DA3B", // Maintain same background color on hover
                  border: "1px solid #8DC63F", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CONFIRM DELETION
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={isReactivateModalOpen}
        onClose={handleCancelReactivate}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="confirm-reactivate-modal"
        aria-describedby="confirm-reactivate-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: {
              xs: "98%", // Mobile
              sm: "85%", // Tablet
              md: "70%", // Small desktop
              lg: "60%", // Large desktop
            },
            maxWidth: "700px",
            // minHeight: {
            //   xs: "200px", // Mobile
            //   sm: "250px", // Tablet
            //   md: "300px", // Small desktop
            //   lg: "350px", // Large desktop
            // },
          }}
        >
          <h3 id="confirm-reactivate-modal" style={{ marginTop: 0, fontSize: "32px" }}>
            Confirm Reactivation
          </h3>
          <p id="confirm-reactivate-description" style={{ fontSize: "20px" }}>
            Are you sure you want to reactivate this doctor?
          </p>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              mt: "10%",
            }}
          >
            <Button
              onClick={handleCancelReactivate}
              className="button button-contained-cancel"
              sx={{
                backgroundColor: "#FFBD8A", padding: "8px 14px", border: "1px solid #FF8D28", borderRadius: "10px", color: "#000000", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#FFBD8A", // Maintain same background color on hover
                  border: "1px solid #FF8D28", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleConfirmReactivate}
              sx={{
                backgroundColor: "#A1DA3B",
                padding: "8px 14px",
                border: "1px solid #8DC63F",
                borderRadius: "10px",
                color: "#000000",
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#A1DA3B", // Maintain same background color on hover
                  border: "1px solid #8DC63F", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CONFIRM REACTIVATION
            </Button>
          </Box>
        </Box>
      </Modal>


      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "auto",
          width: "100%",
          maxWidth: "1200px", // Set a max width for large screens
          // padding: "1rem",
        }}
      >
        <h4 style={{ textAlign: "center" }}>Doctor List</h4>
        {doctorlist.length > 0 ? (
          <div style={{ width: "100%", overflowX: "auto" }}>
            <DataGrid
              rows={doctorlist}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[5, 10]}
              components={{
                Toolbar: () => (
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      mb: 2,
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={8}
                      sx={{ display: "flex", gap: 1 }}
                    >
                      <GridToolbarColumnsButton />
                      <GridToolbarFilterButton />
                      <GridToolbarDensitySelector />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      sx={{
                        display: "flex",
                        gap: 1,
                        justifyContent: { xs: "center", sm: "flex-end" },
                      }}
                    >
                      <Button
                        variant="text"
                        color="primary"
                        onClick={() => generatePdf()}
                        startIcon={<SaveAlt />}
                      >
                        Download PDF
                      </Button>
                      <CSVLink
                        data={generateCsvData()}
                        filename={"Doctors_List.csv"}
                        target="_blank"
                      >
                        <Button
                          variant="text"
                          color="primary"
                          startIcon={<SaveAlt />}
                        >
                          Download CSV
                        </Button>
                      </CSVLink>
                    </Grid>
                  </Grid>
                ),
              }}
              getRowClassName={getRowClassName}
              sx={{
                "& .MuiDataGrid-root": {
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  fontFamily: "Arial, sans-serif",
                  padding: "5px"
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#125386",
                  color: "white",
                  fontSize: "13px",
                  fontWeight: "600",
                  minHeight: "48px !important",
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white",
                    fontWeight: "600",
                    fontSize: "13px",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    padding: "0 12px",
                  },
                  "& .MuiDataGrid-columnHeader:last-child": {
                    borderRight: "none",
                  },
                  "& .MuiDataGrid-iconButtonContainer": {
                    color: "white",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-columnHeaderSortable": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-columnHeaderTitleContainer": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiSvgIcon-root": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-row": {
                  backgroundColor: "white",
                  minHeight: "40px !important",
                  "&:nth-of-type(even)": {
                    backgroundColor: "white",
                  },
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#e3f2fd",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  },
                  borderBottom: "1px solid #e0e0e0",
                },
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #e0e0e0",
                  fontSize: "12px",
                  color: "#374151",
                  padding: "8px 12px",
                  minHeight: "40px !important",
                  "&:last-child": {
                    borderRight: "none",
                  },
                  "&:focus": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: "12px",
                  color: "#374151",
                  fontWeight: "400",
                },
                "& .MuiDataGrid-footerContainer": {
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #e0e0e0",
                  minHeight: "52px",
                },
                "& .MuiTablePagination-root": {
                  color: "#374151",
                  fontSize: "12px",
                },
                "& .MuiDataGrid-toolbarContainer": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "8px 16px",
                },
              }}
            />
          </div>
        ) : (
          <h3>No Doctors are added!!</h3>
        )}
      </div>
    </>
  );
}

export default DoctorList;
